
import React from "react";
import Leads from "./Leads";
import LeadAnalytics from "./LeadAnalytics";
import { Utils } from "../../../../../utils";
import { Elements } from "../../../../shared";
import { IPlatform } from "../../../../../services";
import { AccountMenuItem, i18nManager } from "../../../../../i18n";
import { NavLink, Route, Routes, useSearchParams } from "react-router-dom";

export interface PipelineProps {
    platform?: IPlatform;
}

function Pipeline(props: PipelineProps) {
    const [searchParams, _] = useSearchParams(window.location.search);
    const search = Utils.urlParamsToSearch(searchParams, ["platform_id"]);
    const labels = i18nManager.Labels.dashboard.platform_management.crm.pipeline;

    return (<div className="content support">
        {!props.platform
            ? (<div style={{ margin: "auto"}}>{Elements.LOADING_STATE}</div>)
            : (<React.Fragment>
                <div className="menu">
                    {labels.menu.map((item: AccountMenuItem) => (<NavLink key={item.label} to={{ pathname: item.location, search }}>
                        {item.label}
                    </NavLink>))}
                </div>
                <Routes>
                    <Route path="/leads" element={<Leads platform={props.platform!} />} />
                    <Route path="/leads-analytics" element={<LeadAnalytics platform={props.platform!} />} />
                </Routes>
            </React.Fragment>)}
    </div>);
}

export default Pipeline;
